
import React from 'react';
import _ from "lodash";


import SimpleSelect from 'react-select';
import Textarea from 'react-textarea-autosize';
import * as C from "./constraints.jsx";


export class PlainTextWidget extends React.Component {
    render() {
        let me = this,
            props = me.props,
            //
            id = props.id || ('id_' + props.name),
            name = props.name,
            className = props.className || '',
            inline = props.inline ? ' trit-widget-inline' : '',
            //
            data = props.data,
            value = (data !== undefined ? data[name] : props.value),
            defaultValue = props.defaultValue || '-',
            href = props.href,
            //
            onClick = props.onClick || _.noop,
            isClickable = Boolean(props.onClick) ? ' trit-clickable' : '',
            //
            schema = props.schema,
            validators = props.validators || schema.child(name, value, data) || [],
            vResult = C.validateSchema(value, validators, data),
            vStatus = _.filter(vResult.results, function(v){
                return (v.r === false) & (v.msg !== null);
            }),
            hasError = (vResult.invalid > 0) ? ' has-error': '';

        return (
            <div id={id} className={"trit-widget trit-widget-plaintext" + inline + isClickable + hasError + ' ' + className} onClick={onClick.bind(me)}>
                {(href === null || typeof href == 'undefined' || !value) ? (
                    value||defaultValue
                ) : (
                    <a href={href}>{value}</a>
                )}
            </div>
        );
    }
}


export class StaticTextWidget extends React.Component {
    render() {
        let me = this,
            //
            id = me.props.id || ('id_' + me.props.name),
            name = me.props.name,
            title = me.props.title,
            //
            vertical = me.props.vertical,
            data = me.props.data,
            value = (data !== undefined ? data[name] : me.props.value),
            //
            onRenderValue = me.props.onRenderValue || function(v){ return String(v); };

        if(vertical) {
            return (
                <div className="form-group">
                    <label htmlFor={id}>{title}</label>
                    <p className="form-control-static">{onRenderValue(value)}</p>
                </div>
            );
        } else {
            return (
                <div className="form-group">
                    <label htmlFor={id} className="control-label col-sm-3">{title}</label>
                    <div className="col-sm-9">
                        <p className="form-control-static">{onRenderValue(value)}</p>
                    </div>
                </div>
            );
        }
    }
}


export class FormattedTextWidget extends React.Component {
    render() {
        let me = this,
            //
            id = me.props.id || ('id_' + me.props.name),
            name = me.props.name,
            title = me.props.title,
            //
            vertical = me.props.vertical,
            data = me.props.data,
            //
            onRender = me.props.onRender || function(v){ return 'Ошибка: метод onRender не реализован!'; };

        if(vertical) {
            return (
                <div className="form-group">
                    <label htmlFor={id}>{title}</label>
                    <p className="form-control-static">{onRenderValue(data)}</p>
                </div>
            );
        } else {
            return (
                <div className="form-group">
                    <label htmlFor={id} className="control-label col-sm-3">{title}</label>
                    <div className="col-sm-9">
                        <p className="form-control-static">{onRender(data)}</p>
                    </div>
                </div>
            );
        }
    }
}


export function fromLabelValueCb(v, opts){
    if(_.isNil(v)) return undefined;
    return _.find(opts, function(o) {return (o.value == v); });
}

export function toLabelValueCb(v, opts){
    if(_.isNil(v)) return undefined;
    return v.value;
}


export class SingleSelectWidget extends React.Component {
    render() {
        let me = this,
            //
            id = me.props.id || ('id_' + me.props.name),
            name = me.props.name,
            title = me.props.title,
            data = me.props.data,
            value = (data !== undefined) ? _.get(data, name) : me.props.value,
            //
            cbFromData = me.props.cbFromData || function(v, opts) { return v; },
            cbToData = me.props.cbToData || function(v, opts) { return v; },
            //
            vertical = me.props.vertical,
            onChange = me.props.onChange || function(v, k, ev){},
            onChangeMangled = (function(v, ev) {
                return onChange(cbToData(v, newProps.options), name, ev);
            }).bind(me),
            //
            schema = me.props.schema || {},
            validators = me.props.validators || schema.child(name, value, data) || [],
            vResult = C.validateSchema(value, validators, data),
            vStatus = _.filter(vResult.results, function(v){
                return (v.r === false) && (v.msg !== null);
            }),
            //
            hasError = (vResult.invalid > 0) ? ' has-error' : '',
            bsError = (vResult.invalid > 0) ? ' is-invalid' : ' is-valid',
            bsValidations = (validators.length > 0) ? ' has-validation' : '',
            //
            newProps = _.omit(me.props, [
                'name', 'type', 'title',
                'data', 'value',
                'vertical',
                'schema', 'validators',
                'onChange', 'cbFromData', 'cbToData'
            ]);

        value = cbFromData(value, newProps.options);

        if(vertical) {
            return (
                <div className={"form-group" + bsValidations + hasError}>
                    <label htmlFor={id}>{title}</label>

                    <SimpleSelect
                        id={id}
                        value={value}
                        onChange={onChangeMangled}
                        className={bsError}
                        {...newProps}>
                    </SimpleSelect>

                    {(vStatus.length > 0) ? _.map(vStatus, function(v, k) {
                        return <span key={k} className="invalid-feedback">{v.msg}</span>;
                    }) : null}

                </div>
            );
        } else {
            return (
                <div className={"form-group" + bsValidations + hasError}>
                    <label htmlFor={id} className="control-label col-sm-3">{title}</label>
                    <div className="col-sm-9">
                        <SimpleSelect
                            id={id}
                            value={value}
                            onChange={onChangeMangled}
                            className={bsError}
                            {...newProps}>
                        </SimpleSelect>
                        {(vStatus.length > 0) ? _.map(vStatus, function(v, k) {
                            return <span key={k} className="invalid-feedback">{v.msg}</span>;
                        }) : null}
                    </div>
                </div>
            );
        }
    }
}


export class MultiSelectWidget extends React.Component {
    render() {
        let me = this,
            //
            id = me.props.id || ('id_' + me.props.name),
            name = me.props.name,
            title = me.props.title,
            data = me.props.data,
            value = (data !== undefined) ? _.get(data, name) : me.props.value,
            //
            cbFromData = me.props.cbFromData || function(v, options) { return v; },
            cbToData = me.props.cbToData || function(v, options) { return v; },
            //
            vertical = me.props.vertical,
            onChange = me.props.onChange||function(v, k, ev){},
            onChangeMangled = function(v, k, ev) {
                return onChange(_.map(v||[], function(vf) { return cbToData(vf, newProps.options); }), k, ev);
            },
            //
            schema = me.props.schema || {},
            validators = me.props.validators || schema.child(name, value, data)|| [],
            vResult = C.validateSchema(value, validators, data),
            vStatus = _.filter(vResult.results, function(v){
                return (v.r === false) && (v.msg !== null);
            }),
            //
            hasError = (vResult.invalid > 0) ? ' has-error' : '',
            bsError = (vResult.invalid > 0) ? ' is-invalid' : ' is-valid',
            bsValidations = (validators.length > 0) ? ' has-validation' : '',
            //
            newProps = _.omit(me.props, [
                'name', 'type', 'title',
                'data', 'value',
                'vertical',
                'schema', 'validators',
                'onChange', 'cbFromData', 'cbToData'
            ]);

        value = _.filter(_.map(value||[], function(v) { return cbFromData(v, newProps.options); }), (v) => (typeof v != 'undefined'));

        if(vertical) {
            return (
                <div className={"form-group" + bsValidations + hasError}>
                    <label htmlFor={id}>{title}</label>
                    <SimpleSelect
                        id={id}
                        value={value}
                        onChange={function(v, ev) { return onChangeMangled(v, name, ev); }}
                        isMulti
                        {...newProps}>
                    </SimpleSelect>
                    {(vStatus.length > 0) ? _.map(vStatus, function(v, k) {
                        return <span key={k} className="invalid-feedback">{v.msg}</span>;
                    }) : null}
                </div>
            );
        } else {
            return (
                <div className={"form-group" + bsValidations + hasError}>
                    <label htmlFor={id} className="control-label col-sm-3">{title}</label>
                    <div className="col-sm-9">
                        <SimpleSelect
                            id={id}
                            value={value}
                            onChange={function(v, ev) { return onChangeMangled(v, name, ev); }}
                            isMulti
                            {...newProps}>
                        </SimpleSelect>
                        {(vStatus.length > 0) ? _.map(vStatus, function(v, k) {
                            return <span key={k} className="invalid-feedback">{v.msg}</span>;
                        }) : null}
                    </div>
                </div>
            );
        }
    }
}


export class InputWidget extends React.Component {
    render() {
        let me = this,
            //
            id = me.props.id || ('id_' + me.props.name),
            type = me.props.type || 'text',
            name = me.props.name,
            title = me.props.title || name,
            data = me.props.data,
            value = ((data !== undefined) ? _.get(data, name) : me.props.value) || '',
            //
            schema = me.props.schema || {},
            validators = me.props.validators || schema.child(name, value, data) || [],
            vResult = C.validateSchema(value, validators, data),
            vStatus = _.filter(vResult.results, function(v){
                return (v.r === false) && (v.msg !== null);
            }),
            //
            hasError = (vResult.invalid > 0) ? ' has-error' : '',
            bsError = (vResult.invalid > 0) ? ' is-invalid' : (vResult.total > vResult.skipped) ? ' is-valid' : '',
            bsValidations = (vResult.total > vResult.skipped) ? ' has-validation' : '',
            //
            vertical = me.props.vertical,
            onChange = me.props.onChange||function(v, k, ev){},
            //
            newProps = _.omit(me.props, [
                'name', 'type', 'title',
                'data', 'onChange',
                'schema', 'validators',
                'vertical'
            ]);

        newProps.value = value;

        switch(type) {
            case "checkbox":
                if(vertical) {
                    return (
                        <div className={"form-group" + bsValidations + hasError}>
                            <div className="checkbox">
                                <label htmlFor={id}>&nbsp;</label>
                                <label htmlFor={id}>
                                    <input
                                        id={id} type={type} name={name}
                                        checked={value ? "checked" : ""}
                                        onChange={function(ev){ onChange(ev.target.checked || null, name); }}
                                        {...newProps} />
                                    &nbsp;{title}
                                </label>
                            </div>
                            {(vStatus.length > 0) ? _.map(vStatus, function(v, k) {
                                return <span key={k} className="invalid-feedback">{v.msg}</span>;
                            }) : null}
                        </div>
                    );
                } else {
                    return (
                        <div className={"form-group" + bsValidations + hasError}>
                            <div className="col-sm-3" />
                            <div className="col-sm-9">
                                <div className="checkbox">
                                    <label htmlFor={id}>
                                        <input
                                            id={id} type={type} name={name}
                                            checked={value ? "checked" : null}
                                            onChange={function(ev){ onChange(ev.target.checked || null, name); }}
                                            {...newProps} />
                                        &nbsp;{title}
                                    </label>
                                </div>
                                {(vStatus.length > 0) ? _.map(vStatus, function(v, k) {
                                    return <span key={k} className="invalid-feedback">{v.msg}</span>;
                                }) : null}
                            </div>
                        </div>
                    );
                }

            case "textarea":
                if(vertical) {
                    return (
                        <div className={"form-group" + bsValidations + hasError}>
                            <label htmlFor={id}>{title}</label>
                            <Textarea
                                className={"form-control" + bsError}
                                id={id} type={type} name={name}
                                onChange={function(ev){ onChange(ev.target.value || null, name); }}
                                {...newProps}>
                            </Textarea>
                            {(vStatus.length > 0) ? _.map(vStatus, function(v, k) {
                                return <span key={k} className="invalid-feedback">{v.msg}</span>;
                            }) : null}
                        </div>
                    );
                } else {
                    return (
                        <div className={"form-group" + bsValidations + hasError}>
                            <label htmlFor={id} className="control-label col-sm-3">{title}</label>
                            <div className="col-sm-9">
                                <Textarea
                                    className={"form-control" + bsError}
                                    id={id} type={type} name={name}
                                    onChange={function(ev){ onChange(ev.target.value || null, name); }}
                                    {...newProps} />
                                {(vStatus.length > 0) ? _.map(vStatus, function(v, k) {
                                    return <span key={k} className="invalid-feedback">{v.msg}</span>;
                                }) : null}
                            </div>
                        </div>
                    );
                }

            default:
                if(vertical) {
                    return (
                        <div className={"form-group" + bsValidations + hasError}>
                            <label htmlFor={id}>{title}</label>
                            <input
                                className={"form-control" + bsError}
                                id={id} type={type} name={name}
                                onChange={function(ev){ onChange(ev.target.value || null, name); }}
                                {...newProps} />
                            {(vStatus.length > 0) ? _.map(vStatus, function(v, k) {
                                return <div key={k} className="invalid-feedback">{v.msg}</div>;
                            }) : null}
                        </div>
                    );
                } else {
                    return (
                        <div className={"form-group" + bsValidations + hasError}>
                            <label htmlFor={id} className="control-label col-sm-3">{title}</label>
                            <div className="col-sm-9">
                                <input
                                    className={"form-control" + bsError}
                                    id={id} type={type} name={name} autoComplete="off"
                                    onChange={function(ev){ onChange(ev.target.value || null, name); }}
                                    {...newProps} />
                                {(vStatus.length > 0) ? _.map(vStatus, function(v, k) {
                                    return <div key={k} className="invalid-feedback">{v.msg}</div>;
                                }) : null}
                            </div>
                        </div>
                    );
                }
        }
    }
}


export class RadioSelectWidget extends React.Component {
    render() {
        var
            me = this,
            //
            render_cb = me.props.render_cb || function(v){ return v; },
            value_cb = me.props.value_cb || function(v){ return v; },
            uid_cb = me.props.uid_cb || function(v) { return value_cb(v); },
            //
            title = me.props.title,
            name = me.props.name,
            type = me.props.type || 'radio',
            items = me.props.items,
            data = me.props.data,
            onChange = me.props.onChange || function(v, k){},
            value = (data !== undefined) ? _.get(data, name) : me.props.value,
            //
            schema = me.props.schema || {},
            validators = me.props.validators || schema.child(name, value, data) || [],
            vResult = C.validateSchema(value, validators, data),
            vStatus = _.filter(vResult.results, function(v){
                return (v.r === false) && (v.msg !== null);
            }),
            hasError = (vResult.invalid > 0) ? ' has-error' : '',
            bsError = (vResult.invalid > 0) ? ' is-invalid' : ' is-valid',
            bsValidations = (validators.length > 0) ? ' has-validation' : '',
            //
            props = _.omit(me.props, [
                'render_cb', 'value_cb',
                'name', 'type', 'title',
                'items', 'value', 'data',
                'checked', 'onChange',
                'schema', 'validators'
            ]);

        let selectedUid = uid_cb(value);

        return (
            <div className={"form-group" + bsValidations + hasError}>
                {(title !== undefined) ?
                    (<label for={'id_' + name}>{title}</label>)
                    :
                    null
                }
                {(vStatus.length > 0) ? _.map(vStatus, function(v, k) {
                    return <span key={k} className="invalid-feedback">{v.msg}</span>;
                }) : null}
                <ul className="ul-clear">{_.map(items, function(v, k){
                    var id = 'id_' + name + '_' + k;

                    return (
                        <li key={k}>
                            <div className="radio">
                                <label htmlFor={id}>
                                    <input id={id} type={type} name={name} value={value_cb(v, k)}
                                           onChange={onChange.bind(me, v, name)}
                                           checked={selectedUid == uid_cb(v) ? 'checked' : ''} {...props} />
                                    &nbsp;{render_cb(v, k)}
                                </label>
                            </div>
                        </li>
                    );
                })}</ul>
            </div>
        );
    }
}


export class RadioMultiSelectWidget extends React.Component {
    render() {
        var
            me = this,
            //
            render_cb = me.props.render_cb || _.identity,
            value_cb = me.props.value_cb || _.identity,
            uid_cb = me.props.uid_cb || function(v) { return value_cb(v); },
            //
            title = me.props.title,
            name = me.props.name,
            type = me.props.type || 'checkbox',
            items = me.props.items,
            data = me.props.data,
            onChange = me.props.onChange || function(v, k){},
            value = (data !== undefined) ? _.get(data, name) : me.props.value,
            //
            schema = me.props.schema || {},
            validators = me.props.validators || schema.child(name, value, data) || [],
            vResult = C.validateSchema(value, validators, data),
            vStatus = _.filter(vResult.results, function(v){
                return (v.r === false) && (v.msg !== null);
            }),
            hasError = (vResult.invalid > 0) ? ' has-error' : '',
            bsError = (vResult.invalid > 0) ? ' is-invalid' : (vResult.total > vResult.skipped) ? ' is-valid' : '',
            bsValidations = (vResult.total > vResult.skipped) ? ' has-validation' : '',
            //
            props = _.omit(me.props, [
                'render_cb', 'value_cb',
                'name', 'type', 'title',
                'items', 'value', 'data',
                'checked', 'onChange',
                'schema', 'validators'
            ]);

        let selectedUids = _.map(value, (v) => uid_cb(v));

        return (
            <div className={"form-group" + bsValidations + bsError}>
                {(title !== undefined) ?
                    (<label htmlFfor={'id_' + name}>{title}</label>)
                    :
                    null
                }
                {(vStatus.length > 0) ? _.map(vStatus, function(v, k) {
                    return <div key={k} className="alert alert-danger">{v.msg}</div>;
                }) : null}
                <ul className="ul-clear radio-list">{_.map(items, function(v, k){
                    let
                        id = 'id_' + name + '_' + k,
                        ucbv = uid_cb(v),
                        checkIndex = _.indexOf(selectedUids, ucbv);

                    checkIndex = (checkIndex === -1) ? null : (checkIndex + 1);

                    return (
                        <li key={k} className={"radio" + (checkIndex?' active':'')}>
                            <input id={id} type={type} name={name} value={value_cb(v, k)}
                                    onChange={() => {
                                        let idx = _.indexOf(selectedUids, ucbv),
                                            out = [...value];

                                        if(idx === -1) out.push(v)
                                        else _.pullAt(out, idx);

                                        onChange(out, name);
                                    }}
                                    checked={checkIndex ? 'checked' : ''} {...props}
                            />
                            {render_cb(v, k, checkIndex, id)}
                        </li>
                    );
                })}</ul>
            </div>
        );
    }
}


// TODO: temporarily disable MaskedInput
export class MaskedInputWidget extends React.Component {
    constructor(props) {
        super(props);
        this.controlRef = React.createRef();
    }

    render() {
        var me = this,
            //
            id = me.props.id || ('id_' + me.props.name),
            type = me.props.type || 'text',
            name = me.props.name,
            title = me.props.title,
            //
            placeholder = me.props.placeholder||'Введите значение',
            filler = me.props.filler||'_',
            //
            vertical = me.props.vertical,
            data = me.props.data,
            value = (data !== undefined) ? _.get(data, name) : me.props.value,
            onChange = me.props.onChange||function(v, k){},
            onChangeMangled = (function(ev) {
                let val = (ev.target.value || '').replace(filler, '');
                return onChange(val, name);
            }).bind(me),
            //
            schema = me.props.schema || {},
            validators = me.props.validators || schema.child(name, value, data) || [],
            vResult = C.validateSchema(value, validators, data),
            vStatus = _.filter(vResult.results, function(v){
                return (v.r === false) && (v.msg !== null);
            }),
            //
            hasError = (vResult.invalid > 0) ? ' has-error' : '',
            bsError = (vResult.invalid > 0) ? ' is-invalid' : (vResult.total > vResult.skipped) ? ' is-valid' : '',
            bsValidations = (vResult.total > vResult.skipped) ? ' has-validation' : '',
            //
            props = _.omit(me.props, [
                'name', 'type', 'title',
                'data', 'scheme',
                'value', 'onChange',
                'schema', 'validators',
                'vertical', 'mask'
            ]);

        if(vertical) {
            return (
                <div className={"form-group" + bsValidations + hasError}>
                    <label htmlFor={id}>{title}</label>
                    <input ref={me.controlRef}
                        className={"form-control width-auto" + bsError }
                        id={id} type={type} name={name} value={value||''}
                        onChange={onChangeMangled}
                        {...props} />
                    {(vStatus.length > 0) ? _.map(vStatus, function(v, k) {
                        return <span key={k} className="invalid-feedback">{v.msg}</span>;
                    }) : null}
                </div>
            );
        } else {
            return (
                <div className={"form-group" + bsValidations + hasError}>
                    <label htmlFor={id} className="control-label col-sm-3">{title}</label>
                    <div className="col-sm-9">
                        <input ref={me.controlRef}
                            className={"form-control width-auto" + bsError }
                            id={id} type={type} name={name} value={value||''}
                            placeholder={placeholder}
                            onChange={onChangeMangled}
                            {...props} />
                        {(vStatus.length > 0) ? _.map(vStatus, function(v, k) {
                            return <span key={k} className="invalid-feedback">{v.msg}</span>;
                        }) : null}
                    </div>
                </div>
            );
        }
    }
}


export class DateInputWidget extends React.Component {
    render() {
        return <MaskedInputWidget type="date" mask="11.11.1111" {...this.props} />;
    }
}
